<template>
	<div ref="floatDrag" :style="{ left: left + 'px', top: top + 'px', zIndex: zIndex }" class="levitated_sphere">
		<div style="position: relative;">
			<el-badge :is-dot="newMsg" class="badge-box"></el-badge>
			<div :class="newMsg && userInfo.roleID !== 2 ? 'active' : ''" class="float-position" @mousedown="mouseDown"
			     @mouseout="mouseout" @mouseover="mouseover" @mouseup="mouseUp" @mousemove.prevent>
				<i class="el-icon-service"></i>
				<div v-show="isTelegram && clickFlag" class="hover_telegram">
					<img src="../../assets/logo1.png" style="object-fit: contain">
					<p class="hover_tips">欢迎使用在线客服，需要帮助吗？</p>
				</div>
			</div>
			<div v-show="clickCustom" class="cursom_container">
				<div :class="['custom_connect', clickCustomAmi ? 'on' : 'off']">
					<div v-if="userInfo.roleID !== 2 && chatList.length !== 0" class="chat-fram">
						<div class="search-user">
							<el-autocomplete
								v-model="userInfoId"
								:fetch-suggestions="querySearch"
								:trigger-on-focus="false"
								class="inline-input"
								placeholder="请输入内容"
								suffix-icon="el-icon-search"
								@select="handleSelect"
								:debounce="1000"
							></el-autocomplete>
						</div>
						<div v-for="(item, index) in chatList" :key="index"
						     :class="['user-list', clickUserIndex === index ? 'active' : '']" @click="clickUser(item, index)">
							<div class="user-item">
								<el-avatar src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
								           style="width: 40px; height: 40px;"/>
								<span>{{ item.userName }}</span>
								<el-badge :is-dot="item.status === 2" style="margin-left: 5px;"></el-badge>
							</div>
						</div>
					</div>
					<div class="custom_header">
						<img src="../../assets/logo2.png" style="object-fit: contain"/>
						<span>{{ (userInfo.roleID === 2 || userInfo.roleID === 4) ? '客服' : chatName }}</span>
						<div class="close">
							<el-tooltip class="item" content="tg: @oklacom" effect="light" placement="top">
								<div v-if="userInfo.roleID === 2 || userInfo.roleID === 4" class="bt-tip"
								     @click="handleDrump('https://t.me/oklacom')">
									<i class="iconfont icon-telegram1"></i> <span> &nbsp;&nbsp;添加客服好友</span>
								</div>
							</el-tooltip>
							<i class="el-icon-close close-icon" @click="closeChat"></i>
						</div>
					</div>
					<div :style="{ height: !isChat && (userInfo.roleID === 2 || userInfo.roleID === 4)  ? '540px' : '590px' }"
					     class="custom_dialogue">
						<div ref="chatContainer" class="custom_chat">
							<div v-if="historyChatData.length !== 0 && !isHistory">
								<!-- 历史工单对话记录 -->
								<template v-for="(item, index) in historyChatData">
									<div
										v-if="(item.uid != userInfo.id && (userInfo.roleID === 2 || userInfo.roleID === 4)) || (userInfo.roleID !== 2 && userInfo.roleID !== 4 &&  item.userName !== '客服')"
										:key="index"
										class="u_answer">
										<div class="u_answer_cont">
											<p class="custom_jqr_logo">
												<img src="../../assets/logo1.png" style="object-fit: contain">
											</p>
											<div class="u_answers">
												<p v-if="!isBase64(item.content)" class="a_cont">
													{{ item.content }}
												</p>
												<el-image v-else :initial-index="imgIndex" :preview-src-list="bigImage" :src="item.content"
												          class="img-box" fit="cover" hide-on-click-modal
												          @click="lookBigImg(item.content)"></el-image>
												<span>{{ item.time }}</span>
											</div>
										</div>
									</div>
									<div v-else :key="item.time" class="u_quest">
										<p v-if="!isBase64(item.content)" style="margin-right: 0px;">{{ item.content }}</p>
										<el-image v-else :initial-index="imgIndex" :preview-src-list="bigImage" :src="item.content"
										          class="img-box" fit="cover" hide-on-click-modal
										          @click="lookBigImg(item.content)"></el-image>
										<span>{{ item.time }} </span>
									</div>
								</template>
								<el-alert :closable="false" center
								          style="width: 50%; margin: 30px auto; margin-top: 50px;padding: 5px 0;" title="以上是历史对话"
								          type="info">
								</el-alert>
							</div>
							<el-button v-if="isHistory && isChat && userInfo.roleID === 2" style="margin-top: 20px; width: 50%; "
							           type="success"
							           @click="clickHistory">查看历史记录
							</el-button>
							<!-- 当前工单对话记录 -->
							<template v-for="(item, index) in chatData">
								<!-- 两个不同身份不同的判断条件，客户判断数据id是否登录当前账号id，客服判断数据的username是否等于客服 -->
								<div
									v-if="(item.uid != userInfo.id && (userInfo.roleID === 2 || userInfo.roleID === 4)) || (userInfo.roleID !== 2 && userInfo.roleID !== 4 && item.userName !== '客服')"
									:key="index"
									class="u_answer">
									<div class="u_answer_cont">
										<p class="custom_jqr_logo">
											<img src="../../assets/logo1.png" style="object-fit: contain">
										</p>
										<div class="u_answers">
											<p v-if="!isBase64(item.content)" class="a_cont">
												{{ item.content }}
											</p>
											<el-image v-else :initial-index="imgIndex" :preview-src-list="bigImage" :src="item.content"
											          class="img-box" fit="cover" hide-on-click-modal
											          @click="lookBigImg(item.content)"></el-image>
											<span>{{ item.time }}</span>
										</div>
									</div>
								</div>
								<div v-else :key="item.time" class="u_quest">
									<p v-if="!isBase64(item.content)" style="margin-right: 0px;">{{ item.content }}</p>
									<el-image v-else :initial-index="imgIndex" :preview-src-list="bigImage" :src="item.content"
									          class="img-box" fit="cover" hide-on-click-modal
									          @click="lookBigImg(item.content)"></el-image>
									<span>{{ item.time }}</span>
								</div>
							</template>
							<!-- <template v-for="(item, index) in chatData" v-if="userInfo.roleID === 2">
								<div class="u_answer" v-if="item.uid != $store.state.User.userInfo.id" :key="index">
									<div class="u_answer_cont">
										<p class="custom_jqr_logo">
											<img src="../../assets/telegram-logo.png">
										</p>
										<div class="u_answers">
											<p class="a_cont">
												{{ item.content }}
											</p>
											<span>{{ item.time }}</span>
										</div>
									</div>
								</div>
								<div class="u_quest" v-else :key="index">
									<p style="margin-right: 0px;">{{ item.content }}</p>
									<span>{{ item.time }}</span>
								</div>
							</template>
							<template v-for="(item, index) in chatData" v-else>
								<div class="u_answer" v-if="item.userName !== '客服'" :key="index">
									<div class="u_answer_cont">
										<p class="custom_jqr_logo">
											<img src="../../assets/telegram-logo.png">
										</p>
										<div class="u_answers">
											<p class="a_cont">
												{{ item.content }}
											</p>
											<span>{{ item.time }}</span>
										</div>
									</div>
								</div>
								<div class="u_quest" v-else :key="index">
									<p style="margin-right: 0px;">{{ item.content }}</p>
									<span>{{ item.time }}</span>
								</div>
							</template> -->
							<div v-if="(isFinish && isChat) || (userInfo.roleID !== 2 && userInfo.roleID !==4)"
							     style="margin-top: 50px;margin-bottom: 30px;">
								<el-alert v-if="userInfo.roleID === 2 || userInfo.roleID === 4" :closable="false" center
								          style="width: 80%; margin: 0 auto; padding: 5px 0;"
								          title="检测到您长时间没有新的消息，是否关闭会话？" type="info">
								</el-alert>

								<el-button v-if="chatData.length !== 0" style="margin-top: 20px; width: 25%; font-size: 12px;"
								           @click="endChat">关闭会话
								</el-button>
							</div>
						</div>
					</div>
					<div v-if="!isChat && (userInfo.roleID === 2 || userInfo.roleID === 4)" class="start-chat" @click="startChat">
						<el-button>开始聊天</el-button>
					</div>
					<div v-else class="custom_typing">
						<input id="custom_input_cont" v-model="chatContent" autocomplete="off" maxlength="256"
						       placeholder="输入信息"
						       type="text" @focus="chatFocus" @paste="handlePaste" @keydown.enter="sendOut">
						<i :style="{ color: chatContent == '' ? '#000' : '#36c95f' }" class="el-icon-s-promotion"
						   @click="sendOut"></i>
						<el-upload ref="uploadRef" :before-upload="handleBeforeUpload" :file-list="fileList"
						           :http-request="handleUpload"
						           :show-file-list="false" action="#" class="upload_icon">
							<i class="el-icon-picture"></i>
						</el-upload>
					</div>
				</div>
			</div>
			<!-- <audio id="audio" src="../../assets/提示音.mp3"></audio> -->
		</div>
		<el-dialog :append-to-body="true" :close-on-click-modal="false" :modal-append-to-body="true"
		           :visible.sync="ImageDrawer" class="vindicate"
		           title="发送确认" width="50%">
			<img :src="imageData" alt="" style="width: 100%; height: 100%;max-height: 540px; object-fit: contain;">
			<template #footer>
				<el-button @click="closeImg">取消</el-button>
				<el-button type="primary" @click="sendImg">发送</el-button>
			</template>
		</el-dialog>
		<canvas ref="canvas" style="display: none;"></canvas>
	</div>
</template>
<script>
import {eventBus} from '../../main'
import {
	createFeeback,
	getHistory,
	sendMsg,
	getFeebackStatus,
	closeFeeback,
	getUserFeebacks,
	getPrevHistory,
	replyMsg
} from '@/api/chat'
import {UserModule} from '@/store/module/user'
import _ from 'lodash';
import {searchUser} from "@/api/common";

export default {
	name: "levitated",
	props: {
		distanceRight: {
			type: Number,
			default: 0
		},
		distanceBottom: {
			type: Number,
			default: 100
		},
		isScrollHidden: {
			type: Boolean,
			default: false
		},
		isCanDraggable: {
			type: Boolean,
			default: true
		},
		zIndex: {
			type: Number,
			default: 50
		},
		value: {
			type: String,
			default: "悬浮球！"
		}
	},
	//data 域
	data() {
		return {
			clientWidth: null,
			clientHeight: null,
			left: 0,
			top: 0,
			timer: null,
			currentTop: 0,
			mousedownX: 0,
			mousedownY: 0,
			isTelegram: false,
			clickFlag: true,
			clickCustom: false,
			clickCustomAmi: false,
			clickUserIndex: null,
			isChat: false,
			// 聊天的id
			chatId: '',
			// 聊天内容
			chatData: [],
			// 上一条工单的历史记录
			historyChatData: [],
			chatList: [],
			chatName: '',
			// 输入框聊天内容
			chatContent: '',
			newHistorys: [],
			newMsg: false,
			isFocused: false,
			isFinish: false,
			isHistory: false,
			timingHistory: null,
			timingEnd: null,
			source: null,
			heartbeatInterval: null,
			// 重连节流定时器
			reconnect: null,
			fileList: [],
			ImageDrawer: false,
			imageData: "",
			imgIndex: 0,
			bigImage: [],
			userInfoId: '',

		};
	},
	computed: {
		userInfo() {
			return UserModule.userInfo
		}
	},
	created() {
		// 将重新连接的节流函数实例化并保存到组件实例的属性中
		this.reconnect = _.throttle(function () {
			console.log("Reconnecting...");
			// this.$message({
			//   type: 'error',
			//   message: '连接断开，正在重新连接...'
			// })
			// 延迟一段时间后重新建立连接
			this.createCustomerSSE();
		}, 3000)

		this.clientWidth = document.documentElement.clientWidth;
		this.clientHeight = document.documentElement.clientHeight;
		this.$watch(() => UserModule.userInfo, (oldVal, newVa) => {
			console.log(123);
			if (this.userInfo.roleID === 2 || this.userInfo.roleID === 4) {
				getFeebackStatus().then(res => {
					console.log(res);
					// debugger
					if (res && res.code == 200 && res.status !== -1) {
						// console.log(res);
						this.chatId = res.chatId
						this.startChat()
					}
				})
			} else if (this.$store.state.User.userInfo.roleID === 1) {
				this.createCustomerSSE()
			}
			// 进来后获取对话状态,检测是否有新消息
			this.updateStatuws()
		}, ({deep: true}))
		// 获取全局事件总线
		eventBus.$on('clickCustom', this.handleEvent)
		// 定时检测用户是否长时间未有新消息
		this.timingEnd = setInterval(this.endConversation, 3600000)
	},
	watch: {
		// 监视 historyChatData 的变化
		'historyChatData': {
			handler() {
				// 如果 historyChatData 中有 Base64 内容
				if (this.historyChatData.filter((item) => this.isBase64(item.content)).length > 0) {
					this.historyChatData.forEach((item) => {
						if (this.isBase64(item.content)) {
							this.bigImage.push(item.content);
						}
					});
				}
			},
			deep: true // 深度监视，确保能检测到数组内部的变化
		},
		// 监视 chatData 的变化
		'chatData': {
			handler() {
				// 如果 chatData 中有 Base64 内容
				if (this.chatData.filter((item) => this.isBase64(item.content)).length > 0) {
					this.chatData.forEach((item) => {
						if (this.isBase64(item.content)) {
							this.bigImage.push(item.content);
						}
					});
				}
			},
			deep: true // 深度监视，确保能检测到数组内部的变化
		}
	},
	mounted() {
		this.isCanDraggable &&
		this.$nextTick(() => {
			console.log(this.userInfo);
			this.floatDrag = this.$refs.floatDrag;
			// 获取元素位置属性
			this.floatDragDom = this.floatDrag.getBoundingClientRect();
			// 设置初始位置
			this.left =
				this.clientWidth - this.floatDragDom.width - this.distanceRight - 20;
			this.top =
				this.clientHeight - this.floatDragDom.height - this.distanceBottom;
			this.initDraggable();

		});
		this.isScrollHidden && window.addEventListener("scroll", this.handleScroll);
		window.addEventListener("resize", this.handleResize);
	},
	methods: {
		// 获取用户列表
		async querySearch(queryString, cb) {
			const params = {
				name: queryString
			}
			this.isLoading = true
			await this.initUserList(params, cb)
		},
		// 初始化数据
		async initUserList(params, cb) {
			await searchUser(params)
				.then((res) => {
					// 返回的格式必须是{label: '', value: ''}
					const list = res.data
					const temp = []
					list.forEach((item) => {
						temp.push({
							value: item.name,
							id: item.id
						})
					})
					this.userOptions = temp
					cb(this.userOptions)
				})
				.catch(err => {
					this.$message.error(err.msg)
				})
				.finally(() => {
					this.isLoading = false
				})
		},
		// 选择用户
		handleSelect(item) {
			const params = {
				userId: item.id
			}
			createFeeback(params).then(res => {
				// console.log(this.$store.state.User.userInfo);
				// console.log(res);
				this.getFeebacks()
				this.userInfoId = ''
				// this.history(params)
			})
		},
		// 收到消息时浏览器强制弹出
		showNotification(msg) {
			if ('Notification' in window) {
				// 请求通知权限
				Notification.requestPermission().then(function (permission) {
					// 如果用户同意，就可以向他们发送通知
					if (permission === 'granted') {
						// 创建通知
						const notification = new Notification('有客户给你发信息拉，快点去回复把', {
							body: msg,
							icon: '../../assets/logo.png' // 通知图标路径，可选
						});

						// 可以添加点击通知时的处理逻辑
						notification.onclick = function () {
							// 处理点击通知的逻辑
							// window.location.href = '';
						};
					}
				});
			} else {
				console.log('浏览器不支持Notification API');
			}
		},
		// 查看大图
		lookBigImg(imgUrl) {
			// this.stopObserving()
			this.bigImage.forEach((item, index) => {
				if (item == imgUrl) {
					this.imgIndex = index;
				}
			})
		},
		// 判断图片是否为base64格式
		isBase64(str) {
			const base64Pattern = /^\s*data:(?:[a-z]+\/[a-z0-9-+.]+(?:;[a-z-]+=[a-z0-9-]+)?)?(?:;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*?)\s*$/i
			return base64Pattern.test(str);
		},
		// 将图片转换成base64
		handlePaste(event) {
			console.log(event);
			const canvas = this.$refs.canvas
			const items = event.clipboardData?.items;
			if (items) {
				for (const item of items) {
					if (item.type.startsWith('image/')) {
						const loading = this.$loading({
							lock: true,
							text: '正在上传图片',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						const file = item.getAsFile();
						if (file) {
							const reader = new FileReader();
							reader.onload = (e) => {
								const img = new Image();
								img.onload = () => {
									if (canvas !== null) {
										const ctx = canvas.getContext('2d');
										if (ctx) {
											canvas.width = img.width;
											canvas.height = img.height;

											// 用白色背景填充画布
											ctx.fillStyle = 'white';
											ctx.fillRect(0, 0, canvas.width, canvas.height);

											// 将图片绘制到画布上
											ctx.drawImage(img, 0, 0);

											// 将画布内容转换为WebP
											this.imageData = canvas.toDataURL('image/webp', 0.5);
										}
									}
									if (this.imageData) {
										loading.close();
										this.ImageDrawer = true
									}
								}
								img.src = e.target?.result
							}
							reader.readAsDataURL(file);
						}
					}
				}
			}
		},
		// 限制上传的文件为图片
		handleBeforeUpload(file) {
			const {type} = file
			console.log(type);
			if (!type.startsWith('image/')) {
				this.$message.error('请上传图片')
				return false
			}
		},
		// 上传图片
		handleUpload(e) {
			console.log(e);
			const canvas = this.$refs.canvas
			const {file} = e;
			if (file) {
				if (file.type.startsWith('image/')) {
					const loading = this.$loading({
						lock: true,
						text: '正在上传图片',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					const reader = new FileReader();
					reader.onload = () => {
						const img = new Image();
						img.onload = () => {
							if (canvas !== null) {
								const ctx = canvas.getContext('2d');
								if (ctx) {
									canvas.width = img.width;
									canvas.height = img.height;

									// 用白色背景填充画布
									ctx.fillStyle = 'white';
									ctx.fillRect(0, 0, canvas.width, canvas.height);

									// 将图片绘制到画布上
									ctx.drawImage(img, 0, 0);

									// 将画布内容转换为WebP
									this.imageData = canvas.toDataURL('image/webp', 0.5);
								}
							}
							if (this.imageData) {
								loading.close();
								this.ImageDrawer = true;
							}
						}
						img.src = reader?.result;
						// console.log(e.target?.result);
					}
					reader.readAsDataURL(file);
				}
			}
		},
		// 取消发送图片
		closeImg() {
			this.ImageDrawer = false;
			this.imageData = null;
		},
		// 确认发送图片
		sendImg() {
			this.chatContent = this.imageData
			this.scrollTopBottom()
			this.sendOut()
			this.closeImg()
		},
		// 添加客服好友跳转
		handleDrump(url) {
			if (!url || url === 'undefined') return
			window.open(url)
		},
		// 时间戳转换
		TimestampToDate(Timestamp) {
			let date = new Date(Timestamp * 1000);
			let y = date.getFullYear();
			let m = date.getMonth() + 1;
			let d = date.getDate();
			return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + date.toTimeString().substr(0, 8);
		},
		// 客服接收消息
		createCustomerSSE() {
			//console.log(this.chatId);
			//console.log(this.$store.state.User.userInfo);
			let that = this
			let url = ''
			if (this.$store.state.User.userInfo.roleID === 2 || this.$store.state.User.userInfo.roleID === 4) {
				url = `/chat/sse?chatId=${this.chatId}`
			} else {
				url = '/chat/sse'
				// showNotification()
			}
			// 在创建新连接之前先关闭上一个连接
			if (this.source) {
				console.log('关闭上一个连接');
				this.source.close()
			}

			//console.log(url);
			this.source = new EventSource(url);

			this.source.onopen = function (event) {
				console.log("open");
			};
			this.source.onmessage = function (event) {
				// console.log(event.data);
				let data = JSON.parse(event.data);
				// console.log(data);
				let nowTime = new Date().getTime()
				nowTime = that.TimestampToDate(nowTime / 1000)
				let msg = {
					content: data.msg,
					time: nowTime,
					msgType: data.type,
					userName: data.userName,
					uid: data.uid
				}
				that.getFeebacks()
				if (that.$store.state.User.userInfo.roleID !== 2 && that.$store.state.User.userInfo.roleID !== 4 && data.type !== 'close') {
					that.showNotification(msg.content)
					if (data.chatId === that.chatId && data.type !== 'close') {
						// console.log(msg);
						that.chatData.push(msg);
						that.scrollTopBottom()
					}
				} else {
					that.chatData.push(msg);
					that.scrollTopBottom()
					that.newMsg = true
				}
				if (data.type === 'close') {
					const params = {
						chatId: this.chatId
					}
					closeFeeback(params).then(res => {
						if (res.code === 200) {
							// console.log(res);
							that.isChat = false
							that.isFinish = false
							that.clickUserIndex = null
							that.chatData = []
							that.historyChatData = []
							that.$message({
								type: 'success',
								message: '客服已关闭会话'
							});
							// that.source.close();
							that.source.close()
							that.getFeebacks()
						}
					})
				}
			};
			this.source.onerror = function (event) {
				// 尝试重新建立连接
				console.error('重连');
				that.reconnect();
			};
		},

		// 获取上一个工单的聊天记录
		clickHistory() {
			const params = {
				chatId: this.chatId
			}
			getPrevHistory(params).then(res => {
				this.historyChatData = res.data.reverse()
				this.scrollTopBottom()
				this.isHistory = false
			})
		},
		// 关闭会话
		endChat() {
			this.$confirm('确认关闭会话？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const params = {
					chatId: this.chatId
				}
				closeFeeback(params).then(res => {
					if (res.code === 200) {
						// console.log(res);
						this.isChat = false
						this.isFinish = false
						this.clickUserIndex = null
						this.chatData = []
						this.historyChatData = []
						this.$message({
							type: 'success',
							message: '关闭成功!'
						});
						// this.source.close();
						this.getFeebacks()
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消关闭'
				});
			});
		},
		// 长时间未有新消息，提示关闭会话
		endConversation() {
			const lastChatTime = new Date(this.chatData[this.chatData.length - 1].time).getTime()
			const nowTime = new Date().getTime()
			if (nowTime - lastChatTime > 10800000 && (this.userInfo.roleID === 2 || this.userInfo.roleID === 4)) {
				this.isFinish = true
				this.scrollTopBottom()
			}
		},
		// 客户点击焦点
		chatFocus() {
			if (this.userInfo.roleID === 2 || this.userInfo.roleID === 4) {
				this.newMsg = false
				this.isFocused = true
			}
		},
		// 更新历史记录
		// updateHistory() {
		//   this.updateStatuws();
		//   if (this.isChat !== '') {
		//     const params = {
		//       chatId: this.chatId
		//     }
		//     getHistory(params).then(res => {
		//       this.newHistorys = res.data.reverse()
		//       if (this.chatData.length !== this.newHistorys.length) {
		//         // 有新消息更新聊天状态
		//         this.isFocused = false
		//         this.chatData = this.newHistorys

		//         this.scrollTopBottom();
		//       }
		//     }).catch(err => {
		//       console.log(err);
		//     })
		//   }

		// },
		// 获取聊天状态
		updateStatuws() {
			if (!this.isFocused) {
				const params = {
					chatId: this.chatId
				}
				if (this.userInfo.roleID === 2 || this.userInfo.roleID === 4) {
					getFeebackStatus(params).then(res => {
						this.chatId = res.chatId
						if (res.status === 3) {
							this.newMsg = true
						} else {
							this.newMsg = false
						}
						if (res.status === -1) {
							this.isChat = false
						}
					}).catch(err => {
						console.log(err);
					})
				}
			}
			if (this.userInfo.roleID !== 2 && this.userInfo.roleID !== 4) {
				this.getFeebacks()
			}
		},
		// 始终触底，让聊天框始终在底部
		scrollTopBottom() {
			this.$nextTick(() => {
				const chatContainer = this.$refs.chatContainer;
				// console.log(chatContainer.scrollTop, chatContainer.scrollHeight);
				chatContainer.scrollTop = chatContainer.scrollHeight;
			})

		},
		// 点击开始聊天
		startChat() {
			this.isChat = true
			// 开始聊天，生成历史记录
			this.Feeback()
			this.createCustomerSSE()
			// 触底
			// this.updateStatuws()


		},
		// 全局事件总线，操作其他组件在当前组件中打开聊天框
		handleEvent() {
			this.mouseDown()
			this.mouseUp()
		},
		// 关闭聊天框
		closeChat() {
			this.clickCustomAmi = false
			setTimeout(() => {
				this.clickCustom = false
			}, 600)

		},
		/**
		 * 设置滚动监听
		 * 设置滚动时隐藏悬浮按钮，停止时显示
		 */
		handleScroll() {
			this.timer && clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.handleScrollEnd();
			}, 200);
			this.currentTop =
				document.documentElement.scrollTop || document.body.scrollTop;
			if (this.left > this.clientWidth / 2) {
				// 判断元素位置再左侧还是右侧
				this.left = this.clientWidth + this.floatDragDom.width;
			} else {
				this.left = -this.floatDragDom.width;
			}
		},
		/**
		 * 滚动结束
		 */
		handleScrollEnd() {
			let scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop === this.currentTop) {
				// console.log(this.left);
				if (this.left > this.clientWidth / 2) {
					// 判断元素位置再左侧还是右侧
					this.left = this.clientWidth - this.floatDragDom.width;
				} else {
					this.left = 0;
				}
				clearTimeout(this.timer);
			}
		},
		/**
		 * 窗口resize监听
		 */
		handleResize() {
			this.clientWidth = document.documentElement.clientWidth;
			this.clientHeight = document.documentElement.clientHeight;
			this.checkDraggablePosition();
		},
		/**
		 * 初始化draggable
		 */
		initDraggable() {
			this.floatDrag.addEventListener("touchstart", this.toucheStart);
			this.floatDrag.addEventListener("touchmove", e => this.touchMove(e));
			this.floatDrag.addEventListener("touchend", this.touchEnd);
		},
		mouseDown(e) {
			this.isTelegram = false
			this.clickFlag = false
			const event = e || window.event;
			this.mousedownX = event.screenX;
			this.mousedownY = event.screenY;
			const that = this;
			let floatDragWidth = this.floatDragDom.width / 2;
			let floatDragHeight = this.floatDragDom.height / 2;
			if (event.preventDefault) {
				event.preventDefault();
			}
			this.canClick = false;
			this.floatDrag.style.transition = "none";
			document.onmousemove = function (e) {
				// 按下时让提示框消失
				this.isTelegram = false
				this.clickFlag = false
				var event = e || window.event;
				that.left = event.clientX - floatDragWidth;
				that.top = event.clientY - floatDragHeight;
				if (that.left < 0) that.left = 0;
				if (that.top < 0) that.top = 0;
				if (that.left >= that.clientWidth - floatDragWidth * 2) {
					that.left = that.clientWidth - floatDragWidth * 2;
				}
				if (that.top >= that.clientHeight - floatDragHeight * 2) {
					that.top = that.clientHeight - floatDragHeight * 2;
				}
			};
		},
		mouseUp(e) {
			const event = e || window.event;
			// 控制鼠标悬浮弹窗显示与隐藏
			this.clickFlag = true
			this.isTelegram = false
			//判断只是单纯的点击，没有拖拽
			if (
				this.mousedownY == event.screenY &&
				this.mousedownX == event.screenX
			) {
				console.log(this.userInfo);

				// 点击让聊天框弹起
				this.clickCustom = true
				setTimeout(() => {
					this.clickCustomAmi = true
					this.scrollTopBottom()
				}, 10)

				// 判断是否是管理员，渲染客户数据
				if (this.userInfo.roleID !== 2) {
					this.getFeebacks()
					this.createCustomerSSE()
				}
				// else {
				//   this.updateStatuws()
				//   this.createCustomerSSE()
				// }
			}
			document.onmousemove = null;
			this.checkDraggablePosition();
			this.floatDrag.style.transition = "all 0.3s";


		},
		mouseover() {
			this.isTelegram = true
		},
		mouseout() {
			this.isTelegram = false
		},
		/**
		 * 判断元素显示位置
		 * 在窗口改变和move end时调用
		 */
		checkDraggablePosition() {
			// 判断位置是往左往右滑动
			this.left = this.clientWidth - this.floatDragDom.width - 20;
			// console.log(this.floatDragDom.width);
			// console.log(this.left);
			if (this.top < 53) {
				// 判断是否超出屏幕上沿
				this.top = 53;
			}
			if (this.top + this.floatDragDom.height >= this.clientHeight) {
				// 判断是否超出屏幕下沿
				this.top = this.clientHeight - this.floatDragDom.height;
			}
		},

		// 客服点击聊天框用户高亮
		clickUser(item, index) {
			// console.log(this.chatData);

			if (this.clickUserIndex === index) {
				return;
			}
			item.status = 1
			this.chatId = item.chatId;
			const params = {
				chatId: this.chatId
			}
			this.chatData = []
			this.clickUserIndex = index
			this.isChat = true
			this.isFocused = false
			this.history(params)
			this.clickHistory()

			this.chatName = item.userName;
			this.isHistory = true
			// this.scrollTopBottom()
		},

		// 点击开始聊天后判断有没有历史记录，如果有就显示历史记录，没有就显示聊天框
		Feeback() {
			// 创建聊天
			createFeeback().then(res => {
				// console.log(this.$store.state.User.userInfo);
				// console.log(res);

				this.chatId = res.chatId
				this.isHistory = true

				const params = {
					chatId: this.chatId
				}
				this.history(params)

			})
		},
		// 调用历史记录
		history(params) {
			// 获取历史记录
			getHistory(params).then(res => {
				this.chatData = []
				if (res.data.length > 0) {
					// this.createCustomerSSE()
					// console.log(res);
					this.chatData = res.data.reverse()
					// console.log(this.chatData);
					// 触底
					this.scrollTopBottom()
					// console.log(this.chatData);
					// console.log(this.$store.state.User.userInfo);
				}
			})
		},
		// 发送信息
		sendOut() {
			if (this.chatContent.trim() === '') {
				return;
			}
			let nowTime = new Date().getTime()
			nowTime = this.TimestampToDate(nowTime / 1000)
			let userName = this.userInfo.loginName
			let uid = this.userInfo.id
			if (this.userInfo.id !== 2 || this.userInfo.id !== 4) {
				userName = '客服'
			}
			this.chatData.push({
				content: this.chatContent,
				uid: this.userInfo.id,
				time: nowTime,
				userName: userName,
			})
			this.scrollTopBottom()
			const params = {
				chatId: this.chatId,
				content: this.chatContent,
			}
			this.chatContent = ''
			// console.log(this.chatData);
			if (this.userInfo.roleID === 2 || this.userInfo.roleID === 4) {
				sendMsg(params).then(res => {
					if (res.code === 200) {
						console.log('发送成功');
						const params1 = {
							chatId: this.chatId
						}
						// this.createCustomerSSE()
						this.history(params1)
						this.getFeebacks()
						this.updateStatuws()

					}
				}).catch(err => {
					this.chatData.pop();
				})
			} else {
				replyMsg(params).then(res => {
					if (res.code === 200) {
						console.log(res);
						const params1 = {
							chatId: this.chatId
						}
						this.history(params1)
						this.getFeebacks()
						this.updateStatuws()
					}
				}).catch(err => {
					console.log(err);
				})
			}

		},
		// 获取对话状态
		async getFeebacks() {
			if (this.userInfo.roleID !== 2 && this.userInfo.roleID !== 4) {
				await getUserFeebacks().then(res => {
					this.chatList = res.data
					// 首先按照 lasttime 进行排序，最新时间排在前面
					this.chatList.sort((a, b) => {
						return new Date(b.LastTime) - new Date(a.LastTime);
					});
					this.chatList.sort((a, b) => {
						// 将 status 等于 2 的排到前面
						if (a.status === 2 && b.status !== 2) {
							return -1;
						} else if (a.status !== 2 && b.status === 2) {
							return 1;
						} else {
							return 0;
						}
					});
					let index = 0
					this.chatList.forEach(item => {
						if (item.status !== 2) {
							index++
						}
					})
					if (index !== this.chatList.length) {
						this.newMsg = true
					} else {
						this.newMsg = false
					}
				}).catch(err => {
					console.log("err==>", err);
				})
			}
		},
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
		window.removeEventListener("resize", this.handleResize);
		if (this.timingHistory) {
			this.timingHistory = clearInterval(this.timingHistory);
		}
		if (this.timingEnd) {
			this.timingEnd = clearInterval(this.timingEnd);
		}
		if (this.source) {
			this.source.close()
		}
		clearInterval(this.heartbeatInterval);
	},

};
</script>
<style lang="less" scoped>
@keyframes newMsg {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

::v-deep .badge-box .el-badge__content {
	width: 16px;
	height: 16px;
	animation: newMsg 1s linear infinite alternate;
	position: absolute;
	left: 15px;
	user-select: none;
	top: 6px;
}

::v-deep .el-badge__content.is-fixed.is-dot {
	right: 8px;
	top: 3px;
}

// 滚动条样式
::-webkit-scrollbar {
	width: 8px;
}

::-webkit-scrollbar-thumb {
	background-color: #8b8b8b;
}

::-webkit-scrollbar-thumb:active {
	background-color: #636363;
}

::-webkit-scrollbar-thumb:hover {
	background-color: #636363;
}

.levitated_sphere {
	position: absolute;
	right: 0;
	top: 70%;
	width: 60px;
	user-select: text;
}


.float-position {
	z-index: 10003;
	width: 70px;
	height: 70px;
	background: #36c95f;
	border-radius: 50%;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.8em;
	user-select: none;
	cursor: pointer;

	&.active {
		background-color: #d4746e;
	}

	i {
		color: #fff;
		font-size: 46px;
		transform: rotateY(180deg)
	}

	.hover_telegram {
		position: absolute;
		word-break: break-all;
		box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
		height: 94px;
		border-radius: 4px;
		text-align: center;
		top: -104px;
		right: 25px;
		width: 240px;
		background-color: #fff;

		img {
			width: 48px;
			margin-top: -24px;
		}

		.hover_tips {
			color: #383c43;
			font-size: 14px;
			text-align-last: left;
			margin-top: 14px;
			padding: 0 15px;
		}
	}
}

.on {
	bottom: 40px !important;
}

// .off {
//   bottom: -704px !important;
// }


.custom_connect {
	position: fixed;
	bottom: -704px;
	width: 401px;
	// min-width: 401px;
	max-width: 601px;
	height: 704px;
	// height: 100%;
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
	overflow-y: auto;
	overflow-x: hidden;
	opacity: 1;
	// max-width: 100%;
	max-height: 100%;
	right: 12px;
	transition: .6s;
	display: block;
	background-color: #fff;

	.custom_header {
		width: 401px;
		height: 63px;
		background-color: #333342;
		border-radius: 10px 10px 0px 0;
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		display: flex;
		align-items: center;
		user-select: none;

		img {
			height: 32px;
			margin-left: 25px;
			margin-right: 10px;
		}

		.close {
			flex: 1;
			text-align: right;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.bt-tip {
				// width: 45%;
				padding: 0px 10px;
				height: 35px;
				background: #5764ff;
				border-radius: 5px;
				text-align: center;
				color: #fff;
				cursor: pointer;
				display: flex;
				align-items: center;
				padding-left: 4px;
				margin-left: 30px;
				// position: relative;
				// left: 30px;

				span {
					line-height: 40px;
					font-size: 14px;
					font-weight: normal;
				}

				i {
					font-size: 24px;
				}
			}

		}

		.close-icon {
			margin-left: auto;
			text-align: right;
			margin-right: 20px;
			cursor: pointer;
			user-select: none;
		}
	}


	.custom_dialogue {
		display: flex;
		overscroll-behavior-y: contain;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		flex-direction: column;
		padding: 5px 25px;
		padding-right: 0px;
		height: 590px;
		-webkit-box-flex: 1;
		width: 100%;
		// overflow-y: auto;
		// overflow-x: hidden;
		position: relative;

		.custom_chat {
			overflow-y: auto;
			height: 100%;
		}

		.u_quest {
			text-align: right;
			margin-top: 30px;
			padding-right: 20px;
			position: relative;

			.img-box {
				max-height: 300px;
				max-width: 60%;
				border-radius: 5px;
				border: 1px solid #ddd;
				overflow: hidden;
				user-select: none;
				cursor: pointer;
			}

			p {
				background-color: #36c95f;
				text-align: left;
				transition: .3s;
				border-radius: 10px 0px 10px 10px;
				padding: 10px;
				font-size: 14px;
				color: #fff;
				display: inline-block;
				word-wrap: break-word;
				white-space: pre-wrap;
				max-width: 66%;
			}

			span {
				display: block;
				position: absolute;
				bottom: -20px;
				right: 20px;
				color: #999;
				font-size: 12px;
				line-height: 16px;
			}

		}

		.u_answer {
			margin-top: 20px;
			text-align: left;

			.custom_jqr_logo {
				float: left;
				margin-right: 13px;

				img {
					width: 32px;
					height: 32px;
				}
			}

			.u_answers {
				position: relative;

				.img-box {
					max-height: 300px;
					max-width: 60%;
					border-radius: 5px;
					border: 1px solid #ddd;
					overflow: hidden;
					user-select: none;
					cursor: pointer;
				}

				.a_cont {
					max-width: 260px;
					padding: 0;
					color: #333;
					font-size: 14px;
					background-color: #fafafa;
					border-radius: 0px 10px 10px 10px;
					display: inline-block;
					word-wrap: break-word;
					padding: 10px;
				}

				span {
					display: block;
					position: absolute;
					bottom: -20px;
					left: 50px;
					color: #999;
					font-size: 12px;
					line-height: 16px;
				}
			}
		}
	}

	.start-chat {
		// margin-top: 20px;
		// margin: 0 auto;
		margin-left: 20px;
		width: 100%;
		height: 80px;
		line-height: 80px;
		color: #fff;
		font-size: 16px;
		border: none;
		outline: none;
		position: relative;

		button {
			font-size: 16px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%);
			background-color: #36c95f;
			color: #fff;
			width: 200px;
			height: 50px;
		}
	}

	.custom_typing {
		height: 46px;
		border-top: 1px solid rgb(234, 234, 234);
		padding-right: 20px;
		display: flex;
		align-items: center;
		// justify-content: center;

		.upload_icon {
			margin-left: 12px;
			display: flex;
			align-items: center;
		}

		input {
			font-size: 16px;
			line-height: 20px;
			height: 100%;
			-webkit-box-flex: 1;
			flex: 1 0 0;
			padding: 0 20px;
			background: transparent;
			border: 0;
			color: #333;
		}

		i {
			font-size: 24px;
			transition: all .3s;
			user-select: none;
			cursor: pointer;
		}
	}
}


.cart {
	border-radius: 50%;
	width: 5em;
	height: 5em;
	display: flex;
	align-items: center;
	justify-content: center;
}

.header-notice {
	display: inline-block;
	transition: all 0.3s;

	span {
		vertical-align: initial;
	}

	.notice-badge {
		color: inherit;

		.header-notice-icon {
			font-size: 16px;
			padding: 4px;
		}
	}
}

.drag-ball .drag-content {
	overflow-wrap: break-word;
	font-size: 14px;
	color: #fff;
	letter-spacing: 2px;
}


.chat-fram {
	width: 200px;
	background-color: #ffffff;
	height: 704px;
	overflow-y: auto;
	position: fixed;
	right: 411px;
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
	z-index: 999;

	.search-user {
		padding: 10px;
	}

	// border-radius: 10px;


	.user-list {
		display: flex;
		padding: 10px 0px;
		width: 100%;
		border-bottom: 1px solid #e5e5e5;
		cursor: pointer;
		user-select: none;

		&:last-child {
			border-bottom: 0px;
		}

		&.active {
			background-color: #36c95f;
			color: #fff;
		}

		.user-item {
			display: flex;
			align-items: center;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			width: 200px;
			padding: 0px 10px;


		}

		span {
			white-space: nowrap;
			width: 120px;
			text-align: left;
			margin-left: 5px;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}
</style>
